var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "ship" }, [
        _c("div", { staticClass: "ship__short-info" }, [
          _c("h1", { staticClass: "ship__title" }, [
            _vm._v(_vm._s(_setup.fullName)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "router-link",
                {
                  staticClass: "ship-btn-link btn btn--bluefigma",
                  attrs: { to: _setup.all_cruise_link },
                },
                [_vm._v("Все круизы теплохода")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ship__image-block" },
          [
            _c(_setup.MySlider, {
              staticClass: "cruise-info__slider",
              attrs: {
                slideRatio: 3 / 4,
                slides: _setup.photos,
                srcKey: "src_next",
                idKey: "id",
                titleKey: "title",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ship__full-info" },
        [
          _c("div", [
            _c("a", { attrs: { name: "about-ship" } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ship__about" },
              [
                _setup.has_members()
                  ? _c("div", [
                      _c("div", { staticClass: "ship-crew" }, [
                        _c("h2", { staticClass: "ship-crew__title" }, [
                          _vm._v("Команда теплохода"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ship-crew__list" },
                          [
                            _c(_setup.ShipMember, {
                              attrs: {
                                member: _setup.captain,
                                title: "Капитан",
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.ShipMember, {
                              attrs: {
                                member: _setup.cruise_director,
                                title: "Директор круиза",
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.ShipMember, {
                              attrs: {
                                member: _setup.restaurant_director,
                                title: "Директор ресторана",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  _setup.InsertHtml,
                  _vm._b({}, "InsertHtml", _setup.descriptionBig, false)
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _setup.video
            ? _c("div", [
                _c("iframe", {
                  attrs: {
                    width: "798",
                    height: "449",
                    src: _setup.video,
                    title: _setup.fullName,
                    frameborder: "0",
                    allow:
                      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                    allowfullscreen: "",
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("h2", { staticClass: "ship__section-title" }, [
            _vm._v("Экскурсии"),
          ]),
          _vm._v(" "),
          _setup.excursions.has
            ? _c(
                _setup.InsertHtml,
                _vm._b({}, "InsertHtml", _setup.excursions, false)
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "ship__section-title" }, [
        _vm._v("Схема теплохода"),
      ]),
      _vm._v(" "),
      _c(_setup.BigScheme, { attrs: { scheme: _setup.props.ship.svgjpg } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }